import axios from 'axios'

export const SLOT_EXPOSURE_API_URL = process.env.VUE_APP_SLOT_EXPOSURE_API_URL
  || 'https://dnqrhecfmzenfwmfufgd.supabase.co/functions/v1/slot'

const slotClient = axios.create({
  baseURL: SLOT_EXPOSURE_API_URL,
  withCredentials: false,
})

// 這是匿名的外部 API，不可沿用 CRM 登入 token。
delete slotClient.defaults.headers.common.Authorization
delete slotClient.defaults.headers.Authorization

export async function getSlotContent(slot) {
  const response = await slotClient.get('', {
    params: {
      action: 'text',
      slot,
    },
  })

  return response.data && response.data.data ? response.data.data : null
}

export async function getSlotAssetUrl(slot, viewer) {
  const response = await slotClient.get('', {
    params: {
      action: 'asseturl',
      slot,
      v: viewer,
    },
  })

  return response.data && typeof response.data.data === 'string'
    ? response.data.data
    : null
}

function applyBaseTrackingParams(url, tracking) {
  url.searchParams.set('slot', tracking.slot)
  url.searchParams.set('v', tracking.viewer)
  url.searchParams.set('c', tracking.entityId)
  url.searchParams.set('page', tracking.page)
  return url
}

export function buildTrackedAssetUrl(assetUrl, tracking) {
  if (!assetUrl) return null

  const url = new URL(assetUrl, SLOT_EXPOSURE_API_URL)
  url.searchParams.set('action', 'asset')
  applyBaseTrackingParams(url, tracking)
  // 新版資料口徑需區分 clinic／doctor；舊 asset 範例未列出 t，
  // 多帶此參數可讓已更新的 Edge Function 正確歸戶，未支援時亦會被忽略。
  url.searchParams.set('t', tracking.idType)
  return url.toString()
}

export function buildTrackedOpenUrl(tracking) {
  const url = new URL(SLOT_EXPOSURE_API_URL)
  url.searchParams.set('action', 'open')
  applyBaseTrackingParams(url, tracking)
  url.searchParams.set('t', tracking.idType)
  return url.toString()
}

export function buildSlotEventPayload(tracking, eventType) {
  return {
    slot: tracking.slot,
    event_type: eventType,
    viewer: tracking.viewer,
    clinic_id: tracking.entityId,
    id_type: tracking.idType,
    page: tracking.page,
  }
}

export function recordSlotEvent(payload) {
  return slotClient.post('', payload, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
}
